import { render } from "./Applianceswidget.vue?vue&type=template&id=0d533496"
import script from "./Applianceswidget.vue?vue&type=script&lang=js"
export * from "./Applianceswidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__